interface ErrorStateProps {
  message?: string;
  onRetry?: () => void;
}

export function ErrorState({ message, onRetry }: ErrorStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-14 px-4 text-center rounded-xl border border-red-200 bg-red-50">
      <div className="w-12 h-12 rounded-full bg-white flex items-center justify-center mb-3">
        <i className="ri-error-warning-line text-red-500 text-2xl"></i>
      </div>
      <p className="text-sm font-semibold text-foreground-900">No se pudieron cargar los datos</p>
      {message && <p className="text-xs text-foreground-500 mt-1 max-w-md break-words">{message}</p>}
      {onRetry && (
        <button
          onClick={onRetry}
          className="mt-4 text-sm px-4 py-2 bg-accent-500 text-white rounded-lg hover:bg-accent-600 transition-colors whitespace-nowrap font-medium cursor-pointer"
        >
          <i className="ri-refresh-line mr-1.5"></i>Reintentar
        </button>
      )}
    </div>
  );
}

export function EmptyState({ message = 'No hay registros cargados' }: { message?: string }) {
  return (
    <div className="text-center py-14 text-foreground-500">
      <i className="ri-inbox-line text-3xl block mb-2"></i>
      <p className="text-sm">{message}</p>
    </div>
  );
}